module.exports = __webpack_public_path__ + "img/gb-wls.9f7c50cf.svg";